export default __webpack_public_path__ + "static/media/profile.dee502f8.svg";